import { Container } from '../../../odie';

import { ColorId, CubeBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-------------------------------------------------------------------------
const colorMap: { [key in ColorId]?: string } = {
  blue: 'power/block.cube.blue.png',
  green: 'power/block.cube.green.png',
  purple: 'power/block.cube.purple.png',
  red: 'power/block.cube.red.png',
  yellow: 'power/block.cube.yellow.png',
};

/*
    cube block view
*/
export class CubeBlockView extends Container {
  // init
  //-------------------------------------------------------------------------
  constructor(props: CubeBlockProps) {
    if (!props.color) throw new Error('[CubeBlockView] color is required');
    // create base view
    super();
    this.addChild(new FitWidthBlockSprite(colorMap[props.color] ?? '', props));
    blockPositionView(this, props);
  }

  public static assets(props: Partial<CubeBlockProps>): string[] {
    if (!props.color) throw new Error('[CubeBlockView] color is required');
    return [colorMap[props.color] ?? '', 'fx.cube/'];
  }
}
